import { useEffect } from 'react';

let scriptLoaded = false;
const { recaptchaKey = null } = window.RNZCGP_RECAPTCHA_CONF || { recaptchaKey: null };

export const returnRecaptchaToken = (token) => {
    window.setRecaptchaToken(token);
    return token;
};

export default function useReCaptcha() {
    useEffect(() => {
        if (scriptLoaded || typeof window.grecaptcha !== 'undefined') { return; }
        scriptLoaded = true;

        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        document.body.appendChild(script);

        window.returnRecaptchaToken = returnRecaptchaToken;

        const element = document.createElement('div');
        element.setAttribute('class', 'g-recaptcha');
        element.setAttribute('data-sitekey', recaptchaKey);
        element.setAttribute('data-callback', 'returnRecaptchaToken');
        element.setAttribute('data-size', 'invisible');
        document.body.appendChild(element);
    }, []);
}

export const getCaptchaToken = () => {
    window.grecaptcha.execute();
};

export const resetCaptcha = () => {
    window.grecaptcha.reset();
};
